export default {"src":"/_next/static/media/university.f2881d5a.svg","height":362,"width":674,"blurWidth":0,"blurHeight":0};